export const SET_LOADING = 'SET_LOADING'
export const SET_STREAM_NEW_ENTRIES = 'SET_STREAM_NEW_ENTRIES'

export const SET_ACTIVE = 'SET_ACTIVE'
export const SET_KEY = 'SET_KEY'



// WEBPACK FOOTER //
// ./src/store/modules/app/types.js